import { useState, useEffect } from "react";

/**
 * Custom hook to manage authentication loading states
 * Consolidates multiple loading states into a single, clean interface
 */
export const useSignUpLoading = (signup, isSubmitting) => {
  const [isLocalLoading, setIsLocalLoading] = useState(false);

  // Determine if any loading state is active
  const isLoading = isSubmitting || signup?.isLoading || isLocalLoading;

  // Reset local loading when any auth state changes
  useEffect(() => {
    // Also reset local loading when signup state changes
    if (signup?.errorMessage || !signup?.isLoading) {
      setIsLocalLoading(false);
    }
  }, [signup]);

  // Set local loading (for immediate UI feedback)
  const setLoading = (loading) => {
    setIsLocalLoading(loading);
  };

  return {
    isLoading,
    setLoading,
    isLocalLoading,
  };
};
